<template>
  <v-container fluid>
    <PageTitle>
      <v-icon left>
        fal fa-fw fa-external-link
      </v-icon>
      My Shared Links
    </PageTitle>
    <v-card>
      <v-data-table :headers="headers"
                    :items="links"
                    :items-per-page="form.per_page"
                    :footer-props="{'items-per-page-options': [50, 100, -1]}"
                    :loading="loading">
        <template v-slot:item.created_at="{item: link}">
          {{ link.created_at | datetime(dateFormat) }}
        </template>
        <template v-slot:item.actions="{item: link}">
          <v-menu offset-y>
            <template v-slot:activator="{on, attrs}">
              <v-btn v-bind="attrs"
                     v-on="on"
                     :disabled="!link.presentation_id || !(link.is_clicked || link.type_link || link.message_id)"
                     x-small>
                Actions
                <v-icon right
                        x-small>
                  fas fa-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-list dense
            >
              <v-list-item v-if="link.message_id"
                           @click.prevent="viewMessage(link)"
                           dense>
                <v-list-item-content>
                  <v-list-item-title>
                    View email
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="link.is_clicked && link.presentation_id"
                           @click.prevent="viewActivity(link)"
                           dense>
                <v-list-item-content>
                  <v-list-item-title>
                    View activity
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="link.type_link"
                           dense
                           @click.prevent="copyLink(link)">
                <v-list-item-content>
                  <v-list-item-title>
                    Copy URL to clipboard
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.clicked_at="{item: link}">
          <v-chip v-if="link.clicked_at"
                  label
                  small
                  color="success"
                  dark
                  class="text-center font-weight-bold d-block">
            {{ link.clicked_at | datetime(dateFormat) }}
          </v-chip>
          <v-chip v-else
                  label
                  small
                  color="warning"
                  dark
                  class="text-center font-weight-bold d-block">
            Not clicked yet
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import sharedLinkService from '../../services/sharedLinkService';
import {orderBy} from 'lodash';
import clipboardService from '../../../../ml/services/clipboardService';
import {Form} from 'vform';

export default {
  components: {PageTitle},
  data() {
    return {
      dateFormat: 'YYYY-MM-DD h:mm a',
      form: new Form({
        per_page: 100,
      }),
      loading: false,
      links: [],
    }
  },
  computed: {
    link() {
      return link
    },
    headers() {
      return [
        /*{
          text: 'ID',
          value: 'id',
          width: '80px',
        },*/
        {
          text: 'Date',
          value: 'created_at',
          cellClass: 'text-no-wrap',
          width: '150px',
        },
        {
          text: 'File',
          value: 'presentation.name',
        },
        {
          text: 'Contact',
          value: 'contact.name',
          cellClass: 'text-no-wrap',
        },
        {
          text: 'First Click At',
          value: 'clicked_at',
          width: '140px',
        },
        {
          text: 'Type',
          value: 'type',
          width: '120px',
        },
        {
          text: 'Actions',
          value: 'actions',
          width: '110px',
        }
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        const links = await sharedLinkService.getSharedLinksForCurrentUser(100, 4);
        const presentationLinks = links.filter(link => !!link.presentation_id);
        this.links = orderBy(presentationLinks, ['id'], ['desc']);
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async copyLink(link) {
      await clipboardService.copy(link.share_url)
      this.$toast.success('Link copied to clipboard.');
    },
    async viewActivity(link) {
      const routePrefix = this.$root.routePrefix;
      const routeName = `${routePrefix}.presentation.activity`
      await this.$router.push({name: routeName, params: {presentationID: link.presentation_id}, query: {shared_link_id: link.id}})
    },
    async viewMessage(link) {
      const routePrefix = this.$root.routePrefix;
      const routeName = `${routePrefix}.mailgun.message`;
      await this.$router.push({name: routeName, params: {messageID: link.message_id}})
    },
  }
}
</script>
